import { Author } from './author.model';

export class Article {
  id: number;
  pathImagem: string;
  pathImgListagem: string;
  titulo: string;
  resumo: string;
  conteudo: string;
  dataInclusao: number;
  autor: Author;
  categoria: string;
  palavrasChave: string[];

  imagem?: string;
  palavraChaveStr?: string;
  totalComentarios?: number;

  constructor() {
    this.id = null;
    this.pathImagem = null;
    this.pathImgListagem = null;
    this.titulo = null;
    this.resumo = null;
    this.conteudo = null;
    this.dataInclusao = null;
    this.autor = new Author();
    this.categoria = null;
    this.palavrasChave = [];

    this.imagem = null;
    this.palavraChaveStr = '';
    this.totalComentarios = 0;
  }
}

export class ArticleBanner {
  titulo: string;
  subTitulo: string;
  path: string;
  pathAlternativo: string;
  conteudo: string;
  video: string;

  constructor() {
    this.titulo = null;
    this.subTitulo = null;
    this.path = null;
    this.pathAlternativo = null;
    this.conteudo = null;
    this.video = null;
  }
}